import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import { CostPlanModels } from "modules/costPlan/CostPlanModels";
import { default as firebase, firestore, storage } from "common/Firebase";
import { firestore as firecopy } from "firebase/app";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { CostPlan } from "./models";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { WBSStore } from "modules/WBS/WBSStore";
import { CostPlanExport } from "modules/costPlan/models/CostPlanExport";
import { LoginStore } from "modules/login/LoginStore";
import { Render3dStore } from "modules/render3D/Render3dStore";
import { now } from "utils/FirebaseUtils";
import { gtag } from "ga-gtag";
import { ERowType } from "common/enums";
import { EContentType } from "common/enums";
import { sum, times } from "utils/DecimalUtils";
import { LibraryStore } from "modules/library/LibraryStore";
import { ProjectStore } from "modules/project/ProjectStore";

const removeProperty =
  (prop) =>
  ({ [prop]: _, ...rest }) =>
    rest;
const removeUpdateFileConfig = removeProperty("updateFileConfig");
class Service {
  getFileExtension(filename) {
    return filename.split(".").pop();
  }

  async fetchCostPlans(callback?: any): Promise<void> {
    try {
      let projectSelected = "";
      if (DevelopmentStore.developmentSelected != null) {
        projectSelected = DevelopmentStore.developmentSelected.id;
      } else {
        throw new Error("erro");
      }
      let initState = true;
      LoginStore.clearWbsFileImportSnapshot();
      LoginStore.wbsFileImportSnapshot = await firestore
        .collection("wbsFileImport")
        .where("projectBound", "==", projectSelected)
        .onSnapshot(
          async (snapshot) => {
            let newConstPlanFinished = false;
            let docChanges = snapshot.docChanges();
            if (initState) {
              let change;
              if (docChanges.length === 1) {
                change = docChanges[0];
              }
              if (change) {
                CostPlanStore.wbsSelected = CostPlanModels.CostPlan(change.doc);
                initState = false;
              }
            } else if (CostPlanStore.wbsSelected) {
              for (let change of docChanges) {
                if (
                  change.doc.id === CostPlanStore.wbsSelected.id &&
                  change.type === "modified"
                ) {
                  await firestore
                    .collection("wbsProjectBudget")
                    .doc(WBSStore.currentWbsId)
                    .update({
                      isSelected: false,
                    });

                  CostPlanStore.importCostPlanFileProgess =
                    change.doc.data().progress;
                  CostPlanStore.importCostPlanFileStatus =
                    change.doc.data().status;
                  CostPlanStore.importCostPlanFileErrorMessage =
                    change.doc.data().message;
                  let wasProcessing =
                      CostPlanStore.wbsSelected.data.status === "processing",
                    newCostPlan = CostPlanModels.CostPlan(change.doc);
                  if (
                    wasProcessing &&
                    newCostPlan.data.status === "processed"
                  ) {
                    let wbsSearch = await firestore
                      .collection("wbsProjectBudget")
                      .where(
                        "development",
                        "==",
                        DevelopmentStore.developmentId
                      )
                      .get();

                    let wbsData;
                    if (wbsSearch) {
                      wbsSearch.forEach((doc) => {
                        if (doc.data().isSelected == true) {
                          wbsData = doc.id;
                        }
                      });
                    }

                    CostPlanStore.wbsSelected = false;
                    // WBSStore.reset();
                    await WBSStore.setWbsID(wbsData);
                    await WBSStore.ouvinte(false);
                    newConstPlanFinished = true;
                    /** Adicionei com setTimeou porque o processo de importação aparente
                     * tem um delay grande até fechar a layer de importação. */
                    setTimeout(
                      () => ProjectStore.enableLoadingOnContent(false),
                      20000
                    );
                  }
                  CostPlanStore.wbsSelected = newCostPlan;
                }
              }
            }
            await LibraryStore.resetStore();
            if (newConstPlanFinished) {
              setTimeout(async () => {
                await WBSStore.changeDecimalAndRule();
              }, 3000);
            }
          },
          function (error) {}
        );
      if (callback) {
        callback();
        callback = null;
      }
    } catch (e) {
      console.log(e);
    }
  }

  async addCostPlan(
    file,
    d,
    customProperties
  ): Promise<{ ref: firecopy.DocumentReference; data: any } | void> {
    try {
      let wbsId = WBSStore.currentWbsId;
      const dev = DevelopmentStore.developmentSelected.id,
        description = file.name
          .replace(/_/g, " ")
          .replace(".xlsx", "")
          .replace(".xls", "");

      let uploadTask = storage
        .ref()
        .child("wbsFileImport/" + dev + file.name)
        .put(file);
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        function (snapshot) {
          CostPlanStore.progressStatus =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        }.bind(this)
      );

      let wbsData = await firestore
        .collection("wbsProjectBudget")
        .doc(WBSStore.currentWbsId)
        .get();

      await firestore
        .collection("wbsProjectBudget")
        .doc(WBSStore.currentWbsId)
        .update({
          isSelected: false,
        });

      let wbsName = undefined;
      let wbsCreatedAt = undefined;
      if (wbsData.exists) {
        let wbs = wbsData.data();
        if (wbs != null) {
          wbsName = wbs.nameWbs;
          wbsCreatedAt = wbs.createdAt;
        }
      }

      await uploadTask;
      let costplan = new CostPlan(
        description, //description
        dev + file.name, // fileName
        description, // name
        0, // progress
        "pending", // status
        dev, // wbsProjectBudget
        dev, // projectBound
        "", // message
        "", // type
        now(), // modifyAt
        CostPlanStore.structCodeColumn, // structCodeColumn
        CostPlanStore.alternativeCodeColumn, // alternativeCodeColumn
        CostPlanStore.descriptionColumn, // descriptionColumn
        CostPlanStore.unitColumn, // unitColumn
        CostPlanStore.unitCostColumn, // unitCostColumn
        CostPlanStore.quantityColumn, // quantityColumn
        CostPlanStore.coefficientColumn, // coefficientColumn
        customProperties, // customProperties
        wbsId,
        wbsName,
        wbsCreatedAt
      );
      Render3dStore.resetStore();

      gtag("event", "importacao_plano_custo", {
        importacao_importacao_plano_customodelo: 0,
      });

      let ref = await firestore
        .collection("wbsFileImport")
        .add({ ...costplan });

      let wbsFileImportId = ref.id;
      //
      // await axios.post(
      //   "https://mega-rubk-importcostplan-unznx5bsaa-uc.a.run.app/api/ImportWbs/ImportWbs/Import",
      //   {
      //     id: wbsFileImportId,
      //   }
      // );

      const importCostPlan = firebase
        .functions()
        .httpsCallable("importCostPlanTask");

      await importCostPlan({
        id: wbsFileImportId,
      })
        .then(async (response) => {})
        .catch((error) => {
          console.log(error);
        });

      return {
        ref: ref,
        data: costplan,
      };
    } catch (e) {
      console.log("erro: ", e);
    }
  }

  getRowLaborAndMaterialPrice(WBSRows, id) {
    let priceLabor = 0,
      priceMat = 0,
      priceOther = 0;
    let allChildren = WBSRows.filter((wr) => wr.data.parentTask == id);
    if (allChildren.length == 0) {
      let item = WBSRows.find((wr) => wr.id == id);
      if (item) {
        if (item.data.contentType === EContentType.LABOR) {
          priceLabor = sum(priceLabor, item.data.unitCost);
        } else if (item.data.contentType === EContentType.MATERIAL) {
          priceMat = sum(priceMat, item.data.unitCost);
        } else {
          priceOther = sum(priceOther, item.data.unitCost);
        }
      }
    }
    for (let i = 0; i < allChildren.length; i++) {
      const element = allChildren[i];
      if (element.data.rowType == ERowType.TASK) {
        let {
          priceLabor: tempPriceLabor,
          priceMat: tempPriceMat,
          priceOther: tempPriceOther,
        } = this.getRowLaborAndMaterialPrice(WBSRows, element.id);
        priceLabor = sum(
          priceLabor,
          times(element.data.quantity, tempPriceLabor)
        );
        priceMat = sum(priceMat, times(element.data.quantity, tempPriceMat));
        priceOther = sum(
          priceOther,
          times(element.data.quantity, tempPriceOther)
        );
      } else if (element.data.rowType == ERowType.RESOURCE) {
        if (element.data.contentType === EContentType.LABOR) {
          priceLabor = sum(priceLabor, element.data.total);
        } else if (element.data.contentType === EContentType.MATERIAL) {
          priceMat = sum(priceMat, element.data.total);
        } else {
          priceOther = sum(priceOther, element.data.total);
        }
      }
    }
    return { priceLabor, priceMat, priceOther };
  }

  async DeleteWbs(wbsID: string) {
    let wbs = await firestore.collection("wbsProjectBudget").doc(wbsID);
    wbs.delete();
  }
  async DeleteCostPlan(
    costPlan: firebase.firestore.DocumentReference | string,
    fileName: string
  ): Promise<void> {
    if (typeof costPlan === "string")
      costPlan = firestore.collection("wbsFileImport").doc(costPlan);
    costPlan.delete();
    storage.ref().child(`wbsFileImport/${fileName}`).delete();
  }
  async UpdateCostPlan(
    costPlan: firebase.firestore.DocumentReference | string,
    update: { [field: string]: any }
  ) {
    if (typeof costPlan === "string")
      costPlan = firestore.collection("wbsFileImport").doc(costPlan);
    costPlan.update(update);
  }

  async fetchCostPlansFiles(file: FirebaseDocument<CostPlan>): Promise<any> {
    try {
      const files = await firestore
        .collection("wbsFileImport")
        .where("projectBound", "==", file.data.projectBound)
        .get();

      let array = new Array();
      let dados;
      let eap;

      files.docs.forEach((file) => {
        dados = file.data();
        eap = new CostPlan(
          dados.description,
          dados.fileName,
          dados.name,
          dados.progress,
          dados.status,
          dados.wbsProjectBudget,
          dados.projectBound,
          dados.message,
          dados.type
        );
        array.push(new FirebaseDocument<CostPlan>(dados.id, eap));
      });

      return array;
    } catch (e) {
      console.log(e);
    }
  }

  async DeleteCostPlanByDev(dev: any): Promise<void> {
    try {
      const wbs = await this.fetchCostPlansByDev(dev.id);

      if (wbs) {
        storage
          .ref()
          .child("wbsFileImport/" + wbs[0].data.projectBound)
          .delete();
        await firestore.collection("wbsFileImport").doc(wbs[0].id).delete();
      }
    } catch (e) {
      console.log(e);
    }
  }

  async fetchCostPlansByDev(dev: string): Promise<any> {
    try {
      const files = await firestore
        .collection("wbsFileImport")
        .where("projectBound", "==", dev)
        .limit(1)
        .get();

      let array = new Array();

      files.docs.forEach(function (donut) {
        let dados = donut.data();
        let eap = new CostPlan(
          dados.description,
          dados.fileName,
          dados.name,
          dados.progress,
          dados.status,
          dados.wbsProjectBudget,
          dados.projectBound,
          dados.message,
          dados.type
        );
        array.push(new FirebaseDocument<CostPlan>(donut.id, eap));
      });

      return array;
    } catch (e) {
      console.log(e);
    }
  }

  async moveTakeOffItemsToWbs(newCostPlanId) {
    try {
      let actions = new Array();
      const data = await firestore
        .collection("wbsProjectBudget")
        .doc(WBSStore.wbsID)
        .collection("takeOffFormatedItems")
        .get();

      for (const doc of data.docs) {
        let takeRef = await firestore
          .collection("wbsProjectBudget")
          .doc(newCostPlanId)
          .collection("takeOffFormatedItems")
          .doc();

        const data = doc.data();

        actions.push({
          type: "set",
          args: [takeRef, { ...data }],
        });
      }

      await WBSStore.batchActions(actions, false);
    } catch (e) {
      console.log(e);
    }
  }

  async setCostPlanExportById(docId) {
    let request = false;
    LoginStore.clearWbsFileExportSnapshot();
    LoginStore.wbsFileExportSnapshot = await firestore
      .collection("wbsFileExport")
      .doc(docId)
      .onSnapshot(
        async (snapshot) => {
          CostPlanStore.wbsFileExport = CostPlanModels.CostPlanExport(snapshot);
          if (
            CostPlanStore.wbsFileExport.data.fileName != "" &&
            CostPlanStore.wbsFileExport.data.status != "processed" &&
            !request
          ) {
            CostPlanStore.urlDownload = await CostPlanService.getURLFileXLSX(
              CostPlanStore.wbsFileExport.data.fileName
            );
            request = true;
          }
        },
        function (error) {}
      );
  }

  async setCostPlanExport(devId, wbsProjectBudget) {
    let id = await this.getWBSFileExportId(devId, wbsProjectBudget);
    if (id != "") this.setCostPlanExportById(id);
    else CostPlanStore.wbsFileExport = null;
  }

  async addCostPlanExport(): Promise<void> {
    try {
      CostPlanStore.wbsFileExport = null;
      CostPlanStore.urlDownload = "";
      const dev = DevelopmentStore.developmentSelected.id;
      const name = DevelopmentStore.developmentSelected.data.name;
      const wbsProjectBudget = WBSStore.WBS.id;
      let id = await this.getWBSFileExportId(dev, wbsProjectBudget);

      let costplanExport = new CostPlanExport(
        dev,
        name,
        "pending",
        wbsProjectBudget,
        "",
        ""
      );
      if (id != "") {
        await firestore
          .collection("wbsFileExport")
          .doc(id)
          .set({ ...costplanExport });
      } else {
        id = (
          await firestore.collection("wbsFileExport").add({ ...costplanExport })
        ).id;
      }
      await this.setCostPlanExportById(id);
    } catch (e) {
      console.log("erro: ", e);
    }
  }

  async getWBSFileExportId(devId, wbsProjectBudget) {
    let snapshot = await firestore
      .collection("wbsFileExport")
      .where("development", "==", devId)
      .where("wbsProjectBudget", "==", wbsProjectBudget)
      .limit(1)
      .get();
    if (snapshot.docs[0]) {
      return snapshot.docs[0].id;
    } else {
      return "";
    }
  }

  async getURLFileXLSX(fileName): Promise<string> {
    try {
      var xlsx = storage.ref(`wbsFileExport/${fileName}`);
      let file = await xlsx.getDownloadURL();
      return file;
    } catch (error) {
      console.log("error: ", error);
      return "";
    }
  }

  async handleOrderCostPlans(id: string) {
    let order = WBSStore.listWbs.findIndex((element) => element.id == id);
    if (order == 0) {
      let newId = WBSStore.listWbs[1].id;
      await firestore
        .collection("wbsProjectBudget")
        .doc(id)
        .update({ isSelected: false });
      await firestore
        .collection("wbsProjectBudget")
        .doc(newId)
        .update({ isSelected: true });
      WBSStore.changeCurrentCostPlan(newId);
    } else {
      let newId: string;
      if (order + 1 >= WBSStore.listWbs.length) {
        newId = WBSStore.listWbs[order - 1].id;
      } else {
        newId = WBSStore.listWbs[order + 1].id;
      }

      await firestore
        .collection("wbsProjectBudget")
        .doc(id)
        .update({ isSelected: false });
      await firestore
        .collection("wbsProjectBudget")
        .doc(newId)
        .update({ isSelected: true });
      WBSStore.changeCurrentCostPlan(newId);
    }
  }
  async deleteWbs(id: string) {
    if (id == WBSStore.currentWbsId) {
      await this.handleOrderCostPlans(id);
    }
    await firestore.collection("wbsProjectBudget").doc(id).delete();

    gtag("event", "excluir_plano_custo", {
      excluir_plano_custo: 0,
    });
  }

  async editWbs(id: string, nameWbs: string, description: string) {
    if (nameWbs != "") {
      await firestore.collection("wbsProjectBudget").doc(id).update({
        nameWbs: nameWbs,
      });
      if (id == WBSStore.currentWbsId) {
        await WBSStore.setWbsName();
      }
    }

    if (description != "") {
      await firestore.collection("wbsProjectBudget").doc(id).update({
        description: description,
      });
    }
  }

  async setFileImportConfig(data, userId) {
    await firestore
      .collection("users")
      .doc(userId)
      .update({ updateFileConfig: data });
  }
}

let CostPlanService = new Service();

export { CostPlanService };



// WEBPACK FOOTER //
// ./src/modules/costPlan/CostPlanService.ts